import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { CategoryChips, ChipOption } from '../components/CategoryChips';
import { NumberCard } from '../components/NumberCard';
import { categories, numberTypes } from '../data/categories';
import { allNumbers } from '../data/numbers';
const ease = [0.23, 1, 0.32, 1] as const;
const PAGE_SIZE = 48;
const typeOptions: ChipOption[] = [{
  id: 'all',
  label: 'All types',
  icon: '✦'
}, ...numberTypes.map(type => ({
  id: type.id,
  label: type.plural,
  icon: type.icon
}))];
const categoryOptions: ChipOption[] = [{
  id: 'all',
  label: 'All themes',
  icon: '✦'
}, ...categories.map(category => ({
  id: category.id,
  label: category.label,
  icon: category.icon
}))];
export function Library() {
  const [type, setType] = useState('all');
  const [category, setCategory] = useState('all');
  const [visible, setVisible] = useState(PAGE_SIZE);
  const entries = useMemo(() => allNumbers.filter(entry => (type === 'all' || entry.type === type) && (category === 'all' || (entry.categories as string[]).includes(category))), [type, category]);
  const shown = entries.slice(0, visible);
  const selectType = (id: string) => {
    setType(id);
    setVisible(PAGE_SIZE);
  };
  const selectCategory = (id: string) => {
    setCategory(id);
    setVisible(PAGE_SIZE);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.26,
    ease
  }} data-id="element-148" data-mp="161qugcan6c9">
      <h1 className="text-[26px] font-light leading-tight tracking-tight text-white" data-id="element-149" data-mp="3td08rppguywk">
        Explore angel numbers
      </h1>
      <p className="mt-2 text-[13.5px] leading-relaxed text-lav-dim" data-id="element-150" data-mp="3jlcbv9a54pnp">
        One library, filtered by collection and by theme.
      </p>

      <div className="mt-5 flex flex-col gap-2.5" data-id="element-151" data-mp="kvvp9d9ikjpg">
        <CategoryChips items={typeOptions} active={type} onSelect={selectType} label="Number types" data-id="element-152" data-mp="g4dnimzo2f3f" />
        <CategoryChips items={categoryOptions} active={category} onSelect={selectCategory} label="Number themes" data-id="element-153" data-mp="z0m6f5zuc31s" />
      </div>

      <p className="mt-5 text-[12px] font-medium uppercase tracking-[0.16em] text-lav-dim" data-id="element-154" data-mp="141tg5aljncb3">
        {entries.length} {entries.length === 1 ? 'number' : 'numbers'}
      </p>

      {entries.length === 0 ? <div className="glass mt-3 rounded-3xl px-6 py-10 text-center" data-id="element-155" data-mp="u7jcuxv2ctll">
          <p className="text-[15px] font-semibold text-white" data-id="element-156" data-mp="g8jprun78mrj">No numbers in this combination yet</p>
          <p className="mt-2 text-[13px] leading-relaxed text-lav-dim" data-id="element-157" data-mp="lasjit7wbsup">
            Try a different collection or theme.
          </p>
        </div> : <div className="mt-3 grid grid-cols-2 gap-2.5 sm:grid-cols-3" data-id="element-158" data-mp="bai5x7hy8jf0">
          {shown.map(entry => <NumberCard key={entry.id} entry={entry} variant="tile" data-id="element-159" data-mp="21n7nca4s3rhz" />)}
        </div>}

      {visible < entries.length && <button type="button" onClick={() => setVisible(v => v + PAGE_SIZE)} className="mt-5 flex w-full items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-3.5 text-[13.5px] font-semibold text-lav transition-[background-color,border-color,color] duration-200 ease-smooth hover:border-aura/45 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-aura-bright/70" data-id="element-160" data-mp="25o9lenmylxid">
          Show more numbers
        </button>}

      <p className="mt-8 text-[11.5px] leading-relaxed text-lav-dim/80" data-id="element-161" data-mp="drjch6mv468t">
        Every entry — angel numbers, portal numbers, mirror hours and portal dates — shares the same
        structure, so new numbers can be added at any time.
      </p>
    </motion.div>;
}